<template>
  <el-container>
    <el-header>
      <h2>Caracteristicas de UCAPS</h2>
    </el-header>
    <el-main>
      <el-form label-width="150px">
        <el-card class="mt-4">
          <el-collapse v-model="activeNames">
            <el-collapse-item
              v-for="(item, index) in caracteristicasData"
              :key="index"
              :title="`${item.cara_descripcion}`"
              :name="item.id"
              header-class="custom-header"
            >
              <div class="caracteristicas-container">
                <el-form :model="item">
                  <el-row :gutter="20">
                    <el-col
                      v-for="(valor, i) in item.cara_valores"
                      :key="i"
                      :span="2"
                    >
                      <el-form-item :label="`Valor ${i + 1}`">
                        <el-button
                          v-if="item.editable"
                          type="danger"
                          icon="el-icon-delete"
                          @click="removeValue(index, i)"
                          circle
                          size="mini"
                        ></el-button>
                        <el-input
                          v-model="item.cara_valores[i]"
                          :disabled="!item.editable"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-button type="primary" @click="toggleEdit(index)">
                    {{ item.editable ? 'Guardar' : 'Editar' }}
                  </el-button>
                  <el-button
                    v-if="item.editable"
                    type="text"
                    @click="addValue(index)"
                  >
                    ➕ Agregar Valor
                  </el-button>
                </el-form>
              </div>
            </el-collapse-item>
          </el-collapse>
          <el-button
            type="success"
            @click="updateUcapFeatures"
            class="guardar-cambios"
          >
            Guardar Cambios
          </el-button>
        </el-card>
      </el-form>
    </el-main>
  </el-container>
</template>

<script>
  import { getUcapFeatures, setUcapFeatures } from '@/api/ucap_caracteristicas'
  import { MessageBox } from 'element-ui'
  export default {
    data() {
      return {
        activeNames: [],
        caracteristicasData: [],
        originalData: []
      }
    },
    mounted() {
      this.fetchUcapFeatures()
    },
    methods: {
      async fetchUcapFeatures() {
        try {
          const response = await getUcapFeatures()
          if (response.status === 200 && response.data) {
            this.caracteristicasData = response.data
              .map(item => ({
                cara_id: item.cara_id,
                cara_descripcion: item.cara_descripcion || 'Sin descripción',
                cara_valores: item.cara_valores
                  ? item.cara_valores.split(',')
                  : [],
                editable: false
              }))
              .sort((a, b) =>
                a.cara_descripcion.localeCompare(b.cara_descripcion, 'es', {
                  sensitivity: 'base'
                })
              )
            this.originalData = JSON.stringify(this.caracteristicasData)
          } else {
            console.log('Error en la consulta')
          }
        } catch (error) {
          console.error('Error en la petición:', error)
        }
      },
      async updateUcapFeatures() {
        try {
          const transformedData = this.caracteristicasData.map(item => ({
            cara_id: item.cara_id,
            cara_valores: item.cara_valores.join(',')
          }))
          const response = await setUcapFeatures(transformedData)
          if (response.status === 200) {
            this.fetchUcapFeatures()
            this.originalData = JSON.stringify(this.caracteristicasData)
            this.$message({
              type: 'success',
              message: '¡Cambios guardados exitosamente!'
            })
          } else {
            console.log('Error en la actualización')
          }
        } catch (error) {
          console.error('Error en la petición:', error)
        }
      },
      toggleEdit(index) {
        this.caracteristicasData[index].editable = !this.caracteristicasData[
          index
        ].editable
      },
      addValue(index) {
        this.caracteristicasData[index].cara_valores.push('')
      },
      removeValue(index, i) {
        this.$confirm(
          '¿Estás seguro de que deseas eliminar este valor?',
          'Confirmación',
          {
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'No',
            type: 'warning'
          }
        )
          .then(() => {
            this.caracteristicasData[index].cara_valores.splice(i, 1)
            this.$message({
              type: 'success',
              message: 'Valor eliminado correctamente'
            })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: 'Eliminación cancelada'
            })
          })
      },
      hasUnsavedChanges() {
        return JSON.stringify(this.caracteristicasData) !== this.originalData
      }
    },
    beforeRouteLeave(to, from, next) {
      if (this.hasUnsavedChanges()) {
        MessageBox.confirm(
          'Tienes cambios sin guardar. ¿Seguro que quieres salir?',
          'Confirmación',
          {
            confirmButtonText: 'Sí, salir',
            cancelButtonText: 'No, cancelar',
            type: 'warning'
          }
        )
          .then(() => {
            next()
          })
          .catch(() => {
            next(false)
          })
      } else {
        next()
      }
    }
  }
</script>

<style scoped>
  .mt-4 {
    margin-top: 40px;
  }

  .guardar-cambios {
    margin-top: 20px;
  }

  ::v-deep(.el-collapse-item__header) {
    font-size: 20px;
    font-weight: bold;
  }
</style>
